import * as React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  Stack,
  InputAdornment,
  OutlinedInput,
  Box,
  Checkbox,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { Loader } from "../../../shared";
import { LoadingButton } from "../../../shared";

export const CategoryStoresDialog = (props) => {
  const {
    Items,
    onSearch,
    onSelect,
    disabled,
    onSubmit,
    selectedItems,
    existedStoreList,
    buttonText = "Save",
    type = "add",
    isLoading = false,
    isButtonLoading = false,
    onSelectAll,
  } = props;
  const [value, setValue] = React.useState("");

  const lengthOfTotal = React.useMemo(() => {
    if (type !== "modify") return 0;
    return Items?.length || 0;
  }, [Items, type]);

  const isCheckAllSelected = React.useCallback(() => {
    if (type !== "modify") return false;
    return lengthOfTotal > 0 && selectedItems.length === lengthOfTotal;
  }, [lengthOfTotal, selectedItems, type]);

  const isCheckIndeterminate = React.useCallback(() => {
    if (type !== "modify") return false;
    return (
      lengthOfTotal > 0 &&
      selectedItems.length > 0 &&
      selectedItems.length < lengthOfTotal
    );
  }, [lengthOfTotal, selectedItems, type]);

  return (
    <>
      <Stack
        justifyContent="space-between"
        height="100%"
        gap="8px"
        maxHeight={"calc(100% - 24px)"}
      >
        <FormControl
          size="small"
          fullWidth={true}
          sx={{
            pt: "24px",
          }}
        >
          <OutlinedInput
            placeholder="Search stores"
            sx={{
              height: "48px",
              ".MuiOutlinedInput-input": {
                pl: "0px !important",
              },
            }}
            size="small"
            value={value}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon size="large" />
              </InputAdornment>
            }
            endAdornment={
              value &&
              onSearch && (
                <InputAdornment
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setValue("");
                    onSearch("");
                  }}
                  position="end"
                >
                  <CloseIcon size="large" />
                </InputAdornment>
              )
            }
            fullWidth
            onChange={(e) => {
              const text = e.target.value;
              setValue(text);
              onSearch && onSearch(text);
            }}
          />
        </FormControl>

        <Box sx={{ height: "100%", overflow: "auto" }} fullWidth>
          {Items && Items.length > 0 ? (
            <List sx={{ width: "100%", py: 0, bgcolor: "background.paper" }}>
              {type === "modify" && (
                <ListItem disablePadding>
                  <ListItemButton
                    dense
                    sx={{
                      "&:hover": {
                        backgroundColor: "rgba(21, 96, 212, 0.08)",
                        borderRadius: "8px",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "32px",
                      }}
                    >
                      <Checkbox
                        edge="start"
                        checked={isCheckAllSelected()}
                        indeterminate={isCheckIndeterminate()}
                        onChange={(e) =>
                          onSelectAll && onSelectAll(e.target.checked)
                        }
                        disableRipple
                        inputProps={{ "aria-labelledby": "all-stores" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      id="all-stores"
                      primary="Select All"
                      sx={{
                        "& .MuiTypography-root": {
                          fontWeight: 600,
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              )}

              {Items.map((store) => {
                const labelId = `checkbox-list-label-${store.id}`;
                const isSelected = selectedItems.includes(store.id);

                return (
                  <ListItem key={store.id} disablePadding>
                    <ListItemButton
                      dense
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(21, 96, 212, 0.08)",
                          borderRadius: "8px",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: "32px",
                        }}
                      >
                        <Checkbox
                          edge="start"
                          checked={isSelected}
                          onChange={(e) =>
                            onSelect && onSelect(store.id, e.target.checked)
                          }
                          disableRipple
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        id={labelId}
                        primary={store.name}
                        secondary={store.location || ""}
                        sx={{
                          "& .MuiTypography-root": {
                            fontWeight: 500,
                          },
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          ) : isLoading ? (
            <Loader />
          ) : (
            <Stack justifyContent="center" alignItems="center" height="100%">
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="caption"
                color="text.secondary"
                fontWeight={400}
              >
                There is no stores found
              </Typography>
            </Stack>
          )}
        </Box>

        <LoadingButton
          sx={{ height: "48px" }}
          fullWidth
          variant="contained"
          disabled={disabled}
          loading={isButtonLoading}
          onClick={onSubmit}
        >
          {buttonText}
        </LoadingButton>
      </Stack>
    </>
  );
};
